const tldsInCart = (cartItems) => {
  return cartItems.map((cartItem) => {
    return cartItem.fullDomain.substring(cartItem.fullDomain.indexOf("."));
  });
};
export default tldsInCart;
